var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import { useUpdate } from 'src/shared/hooks/useLifecycle';
import { PERCENT_FOR_ANSSI_VALIDATION } from '../constants';
import styles from './TimeViewedValidation.module.scss';
import { IDENTIFIER_VIDEO_PLAYER_TIME_VALIDATION } from 'src/ui/components/VideoPlayer/constants';
export var TimeViewedValidation = function (props) {
    var _a, _b;
    var timeViewed = props.timeViewed, duration = props.duration, isFullScreen = props.isFullScreen;
    var _c = useState(false), isValid = _c[0], setIsValid = _c[1];
    var baseStaticPublic = "".concat(window['basePath'], "/static/img/");
    useUpdate(function () {
        var percentViewed = (timeViewed * 100) / duration;
        setIsValid(percentViewed > PERCENT_FOR_ANSSI_VALIDATION);
    }, [timeViewed]);
    var logoShield = isValid ? 'shield-check' : 'shield';
    var imageClassName = classNames(styles.timeViewedValidationImage, (_a = {}, _a[styles.check] = isValid, _a));
    return (_jsx("div", __assign({ "data-test": IDENTIFIER_VIDEO_PLAYER_TIME_VALIDATION, className: classNames(styles.timeViewedValidationWrapper, (_b = {}, _b[styles.fullScreen] = isFullScreen, _b)) }, { children: _jsx("img", { alt: "protect", src: "".concat(baseStaticPublic, "/icons/").concat(logoShield, ".svg"), className: imageClassName }) })));
};
